import api from '../../services/service_invoice'
import api2 from '../../services/service_receive'
import api3 from '../../services/service_process'
import Swal from 'sweetalert2'
import Datepicker from 'vuejs-datepicker'

export default {
  components: {
    Datepicker
  },
  data() {
    return {
      amount_payment: 0,
      header: {
        headers: {
          'access-token': this.$store.state.token
        }
      },
      data_bill: '',
      description: '',
      date: this.dateFormatDMY2(new Date())
    }
  },
  methods: {
    getInvoice(id) {
      this.$store.state.isLoading = true
      api.searchDetail(
        id,
        this.header,
        result => {
          console.log('API Result (getInvoice):', result)
          if (result.response === true) {
            this.data_bill = result.data
            if (this.data_bill.debug_sql) {
              console.log('Debug SQL (getInvoice):', this.data_bill.debug_sql)
              console.log('Debug Count (getInvoice):', this.data_bill.debug_count)
              console.log('Raw Maps:', this.data_bill.raw_maps)
            }
            this.data_bill.history_income.forEach(val => {
              if (parseInt(val['payment_status']) !== 1) {
                val['checked'] = true
              } else {
                val['checked'] = false
              }
              val['water_income'].forEach(w => {
                if (val['water_amount'] === undefined) {
                  val['water_amount'] = parseInt(w['water_income_price'])
                } else {
                  val['water_amount'] += parseInt(w['water_income_price'])
                }
              })
            })
            this.data_bill.history_income.forEach(val => {
              val['other_income'].forEach(o => {
                if (val['other_amount'] === undefined) {
                  val['other_amount'] = parseInt(o['price'])
                } else {
                  val['other_amount'] += parseInt(o['price'])
                }
              })
            })
            this.calAmountPayment()
          } else {
            this.data_bill = ''
            Swal.fire('ดึงข้อมูลใบแจ้งหนี้', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.data_bill = ''
          this.$store.state.isLoading = false
        }
      )
    },
    calAmountPayment() {
      this.amount_payment = 0
      this.data_bill.history_income.forEach(val => {
        if (val['checked'] === true) {
          this.amount_payment +=
            parseFloat(val['total_amount']) - parseFloat(val['payment_amount'])
        }
      })
    },
    modal() {
      this.description = ''
      // eslint-disable-next-line no-undef
      $('#summaryModalCenter').modal('show')
    },
    checkout(type) {
      // eslint-disable-next-line no-undef
      $('#summaryModalCenter').modal('hide')
      let data = []
      this.data_bill.history_income.forEach(val => {
        if (val['checked'] === true) {
          data.push({
            history_income_id: val['history_income_id']
          })
        }
      })
      var obj = {
        invoice_id: this.data_bill.invoice_id,
        invoice_payment: this.amount_payment,
        receive_date: this.dateFormatDMY2(this.date),
        payment_status: type,
        description: this.description,
        history_income: data
      }
      // alert(JSON.stringify(obj))
      this.$store.state.isLoading = true
      api2.addReceive(
        obj,
        this.header,
        result => {
          if (result.response === true) {
            Swal.fire('รับชำระใบแจ้งหนี้', result.data, 'success')
            this.$router.push({ name: 'Receipt', params: { id: result.id } })
          } else {
            this.data_bill = ''
            Swal.fire('รับชำระใบแจ้งหนี้', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.data_bill = ''
          this.$store.state.isLoading = false
        }
      )
    },
    export_invoice() {
      $('#PrintInvoiceDetail').modal('hide')
      var obj = {
        search: this.data_bill.invoice_docno,
        zone: '',
        date: this.month,
        active_page: 1,
        per_page: 1
      }
      this.$store.state.isLoading = true
      api.searchInvoice(
        obj,
        this.header,
        result => {
          if (result.response === true) {
            document.getElementsByName(
              'data_invoice'
            )[0].value = JSON.stringify(result.data.pagination)
            document.getElementsByName('config')[0].value =
              sessionStorage.config
            this.$refs.printInvoceAll.submit()
          } else {
            Swal.fire('ดึงข้อมูลใบแจ้งหนี้', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    newProcess(id) {
      Swal.fire({
        title: 'ประมวลผลใบแจ้งหนี้?',
        text: 'ท่านต้องการประมวลผลใบแจ้งหนี้ใหม่ใช่หรือไม่ ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ยกเลิก',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          var obj = {
            'invoice_id': id
          }
          this.$store.state.isLoading = true
          api3.processInvice(
            obj,
            this.header,
            result => {
              console.log('API Result (processInvice):', result)
              if (result.response === true) {
                Swal.fire('ประมวลผลใบแจ้งหนี้', result.message, 'success')
              } else {
                Swal.fire('ประมวลผลใบแจ้งหนี้', result.message, 'warning')
              }
              this.getInvoice(id)
              this.$store.state.isLoading = false
            },
            error => {
              alert(JSON.stringify(error))
              this.$store.state.isLoading = false
            }
          )
        }
      })
    }
  },
  mounted() {
    this.getInvoice(this.$route.params.key)
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/invoice_detail.js